import fetch from '@/api/fetch'

/**
 * 获取拼购详情页
 * @param {Object} params - 包含orderNo属性.
 */
export function getGroupOnShareDetailApi(params) {
  return fetch({
    method: 'post',
    url: '/groupon/share/detail',
    params
  })
}

/**
 * 获取拼购详情页
 * @param {Object} params - 包含orderNo属性.
 */
export function getGroupOnPaySuccessApi(params) {
  return fetch({
    method: 'post',
    url: '/order/groupOnPaySuccess',
    params,
    showErrorPage: true
  })
}

/**
 * 拼购分享链接
 * @param {Object} params
 */
export function getGroupOnShareLinkApi(params) {
  return fetch({
    method: 'post',
    url: '/groupon/share/link',
    params,
    showErrorPage: true
  })
}

/**
 * 拼购分享海报
 * @param params
 * @returns {AxiosPromise}
 */
export function getGroupOnSharePosterApi(params) {
  return fetch({
    method: 'post',
    url: '/groupon/share/poster',
    params
  })
}

/**
 * 获取推荐信息
 */
export function getRecommendApi({ spuId, skuId, actCode }) {
  return fetch({
    url: '/groupon/recommend/commodity',
    params: {
      spuId,
      skuId,
      actCode
    }
  })
}

export function getSkuInfoApi(params) {
  return fetch({
    url: '/groupon/getDetail',
    params
  })
}
